import { axiosV4 } from "../../../Utils/Axios/axiosV4";

export const getKonkurYearsService = async (
  userToken: string,
) => {
  return axiosV4.get(`/user/konkur-booklets/years`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
